const a={headline1:"headline1",headline2:"headline2",headline3:"headline3",large:"large",basic:"basic",small:"small",interface:"interface",button:"button",section:"section"},s={normal:"normal",emphasis:"emphasis",headline:"headline"};export{a as sizes,s as themes};
//# sourceMappingURL=text.types.js.map
